import React, { memo } from 'react'
import { useFilter } from './Filter'
import { StyledSearch } from './styles'

export type SearchBoxProps = {
  id: string
  placeholder?: string
}

export const UnMemoizedSearchBox = ({ id, placeholder = 'Search...' }: SearchBoxProps) => {
  const { onChange } = useFilter()

  const onSearch = React.useCallback(
    (query: string) => {
      onChange(id, query.toLocaleLowerCase())
    },
    [id, onChange],
  )

  return (
    <StyledSearch>
      <i className="fa fa-search search-icon" />
      <input
        id={id}
        type="text"
        placeholder={placeholder}
        onChange={e => onSearch(e.target.value)}
      />
    </StyledSearch>
  )
}

export const SearchBox = memo(UnMemoizedSearchBox)
